// extracted by mini-css-extract-plugin
export default {"modalOverlay":"FM-z","modalContent":"GM-z","header":"HM-z","close":"IM-z"};